"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrPositions = exports.toastTypes = void 0;
var toastTypes = {
  DEFAULT: 'toast-default',
  ERROR: 'toast-error',
  WARNING: 'toast-warning',
  SUCCESS: 'toast-success',
  INFO: 'toast-info'
};
exports.toastTypes = toastTypes;
var toastrPositions = {
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right'
};
exports.toastrPositions = toastrPositions;
//# sourceMappingURL=constants.js.map